import { useState, useEffect } from "react";
import { api } from "./api";

export function useSponsors(placement) {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/sponsors", { params: placement ? { placement } : {} })
      .then(({ data }) => { if (alive && Array.isArray(data)) setSponsors(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [placement]);
  return sponsors;
}

export function trackClick(id) {
  api.post(`/sponsors/${id}/click`).catch(() => {});
}

export function trackImpression(id, placement) {
  try {
    const key = `imp_${placement}_${id}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch { /* ignore */ }
  api.post(`/sponsors/${id}/impression`).catch(() => {});
}
